module.exports = __webpack_public_path__ + "img/img_search_empty@2x.4a923369.png";